/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import { useAttrs } from 'vue';
export default {
  props: {
    modelValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    searchColumns: {
      type: Array,
      required: true
    },
    showLabel: false,
    loading: false,
    show: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    reset: {
      type: Boolean,
      default: true
    },
    width: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      attrs: useAttrs(),
      currentValue: this.modelValue,
      grid: {
        xl: 6,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      collapse: false
    };
  },
  watch: {
    modelValue: function modelValue(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('update:modelValue', val);
    },
    show: function show(val) {
      val && this.$refs.searchForm.resetFields();
    }
  },
  computed: {
    hasSlot: function hasSlot() {
      var _this = this;
      return function (name) {
        return !!_this.$slots[name];
      };
    },
    colSpan: function colSpan() {
      if (this.width) {
        return {};
      } else {
        return {
          xs: 24,
          sm: 8,
          md: 8,
          lg: 8,
          xl: 4,
          xxl: 3
        };
      }
    },
    customStyle: function customStyle() {
      var style = {};
      if (this.width) {
        style.width = this.width;
        style.minWidth = this.width;
      }
      return style;
    }
  },
  methods: {
    handleSearch: function handleSearch() {
      this.$emit("search");
    },
    handleReset: function handleReset() {
      this.$refs.searchForm.resetFields();
      this.$emit("reset");
    }
  }
};